import { Dropdown, Pagination } from "react-bootstrap";
import { useTheme } from "../hooks/ThemeProvider";

/**
 * Reusable Pagination Component
 *
 * @param {number} currentPage - Current page number
 * @param {number} totalItems - Total number of items
 * @param {number} perPage - Items per page
 * @param {function} onPageChange - Callback when page is changed
 * @param {function} onPerPageChange - Callback when perPage value is changed
 */
export default function PaginationSection({
  currentPage = 1,
  totalItems = 50,
  perPage = 10,
  onPageChange = () => {},
  onPerPageChange = () => {},
}) {

  const totalPages = Math.ceil(totalItems / perPage);
  const { theme } = useTheme();
  const start = (currentPage - 1) * perPage + 1;
  const end = Math.min(currentPage * perPage, totalItems);

  // Generate pagination numbers (simplified)
  const pageNumbers = [];
  for (let i = 1; i <= Math.min(totalPages, 5); i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="pagination_main">
      {/* Left side */}
      <div className="left_side">
        <h6>
          Showing {start} - {end} out of {totalItems}
        </h6>

        {/* Per Page Dropdown */}
        <Dropdown onSelect={(val) => onPerPageChange(Number(val))}>
          <Dropdown.Toggle variant="success" id="dropdown-basic">

            {perPage}
             {
                theme === 'dark' ? <img src="/assets/droparrow.svg" alt="arrow" /> :
                 <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M3 4.5L6 7.5L9 4.5" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }

          </Dropdown.Toggle>

          <Dropdown.Menu>
            {[10, 25, 50, 100].map((val) => (
              <Dropdown.Item key={val} eventKey={val}>
                <div className="drop_inside">
                  <h5>
                    Show: <span>{val} per page</span>
                  </h5>
                  {val === perPage && <img src="/assets/bluetick.svg" alt="tick" />}
                </div>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Right side pagination */}
      <div className="right_side">
        {/* Prev Arrow */}
        <div
          className={`arrows ${currentPage === 1 ? "disabled" : ""}`}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        >


            {
                theme === 'dark' ?     <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
            <path
              d="M7.5 3L4.5 6L7.5 9"
              stroke="#243D70"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
                  : <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M7.5 3L4.5 6L7.5 9" stroke="#DEE1E7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }

        </div>

        {/* Page Numbers */}
        <div className="inner_middle">
          {pageNumbers.map((page) => (
            <span
              key={page}
              className={page === currentPage ? "active" : ""}
              onClick={() => onPageChange(page)}
            >
              {page}
            </span>
          ))}
          {totalPages > 5 && (
            <>
              <span>...</span>
              <span onClick={() => onPageChange(totalPages)}>{totalPages}</span>
            </>
          )}
        </div>

        {/* Next Arrow */}
        <div
          className={`arrows ${currentPage === totalPages ? "disabled" : ""}`}
          onClick={() =>
            currentPage < totalPages && onPageChange(currentPage + 1)
          }
        >

            {
                theme === 'dark' ?      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
            <path
              d="M4.5 9L7.5 6L4.5 3"
              stroke="#243D70"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
                  : <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M4.5 9L7.5 6L4.5 3" stroke="#DEE1E7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }
        </div>
      </div>

      {/* Mobile Pagination */}
      <div className="mainpagi d-none">
        <div className="mainparent">
          <div className="right">
            <img src="/leftarrow.png" alt="left" className="img-fluid" />
            <Pagination>
              {pageNumbers.map((page) => (
                <Pagination.Item
                  key={page}
                  active={page === currentPage}
                  onClick={() => onPageChange(page)}
                >
                  {page}
                </Pagination.Item>
              ))}
              {totalPages > 5 && (
                <>
                  <Pagination.Ellipsis />
                  <Pagination.Item onClick={() => onPageChange(totalPages)}>
                    {totalPages}
                  </Pagination.Item>
                </>
              )}
            </Pagination>
            <img src="/rightarrow.png" alt="right" className="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  );
}
